<div class="divStackbar">
    <canvas baseChart 
      [datasets]="barChartData"
      [options]="barChartOptions"
      [colors]="chartColors"
      [legend]="barChartLegend"
      [chartType]="barChartType">
    </canvas>
  </div>
  